import {
  ChangePasswordParams,
  LoginParams,
  SocialLoginParams,
  User
} from '~core/models/auth.models';
import { CompanyListParams } from '~core/models/company.models';

export class LoginWithPassword {
  static readonly type = '[Auth] Login With Password';
  constructor(public data?: LoginParams) {}
}

export class LoginWithOneTimePassword {
  static readonly type = '[Auth] Login With One Time Password';
  constructor(public data: string) {}
}

export class LoginWithSocialNetwork {
  static readonly type = '[Auth] Login With Social Network';
  constructor(public data: SocialLoginParams) {}
}

export class GetRegistrationOneTimePassword {
  static readonly type = '[Auth] Get Registration One Time Password';
}

export class RegisterUser {
  static readonly type = '[Auth] Register User';
  constructor(public data?: string) {}
}

export class GetResetOneTimePassword {
  static readonly type = '[Auth] Get Reset One Time Password';
}

export class ResetUserPassword {
  static readonly type = '[Auth] Reset User Password';
}

export class ChangeUserPassword {
  static readonly type = '[Auth] Change User Password';
  constructor(public data: ChangePasswordParams) {}
}

export class RefreshAccessToken {
  static readonly type = '[Auth] Refresh Access Token';
}

export class ResetLoginState {
  static readonly type = '[Auth] Reset LoginState';
}

export class ResetRegisterState {
  static readonly type = '[Auth] Reset Register State';
}

export class SetLastRequestedRoute {
  static readonly type = '[Auth] Set Last Requested Route';
  constructor(public data: string) {}
}

export class NavigateToLastRequestedRoute {
  static readonly type = '[Auth] Navigate To Last Requested Route';
}

export class Logout {
  static readonly type = '[Auth] Logout';
}

export class PatchLoggedUser {
  static readonly type = '[Auth] Patch Logged User';
  constructor(public data: Partial<User>) {}
}

export class PatchUserExistenceStatus {
  static readonly type = '[Auth] Patch User Existence Status';
  constructor(public data: boolean) {}
}

export class GetUserProfile {
  static readonly type = '[Auth] Get User Profile';
}

export class HydrateFromStorage {
  static readonly type = '[Auth] Hydrate From Storage';
}

export class GoToNextRegistrationStep {
  static readonly type = '[Auth] Go To Next Registration Step';
}

export class GoToPreviousRegistrationStep {
  static readonly type = '[Auth] Go To Previous Registration Step';
}

export class GoToRegistrationStep {
  static readonly type = '[Auth] Go To Registration Step';

  constructor(public payload: number) {}
}

export class IdentifyUserCompany {
  static readonly type = '[Auth] Identify User Company';
  constructor(public data?: CompanyListParams) {}
}

export class CheckEmailExistence {
  static readonly type = '[Auth] Check Email Existence';
  constructor(public email: string) {}
}

export class ResetOnboardingForms {
  static readonly type = '[Onboarding] Reset Onboarding Forms';
}

export class HydrateLoggedUserProfile {
  static readonly type = '[Auth] Hydrate Logged User Profile';
}
